import { RouterAwareLink } from '../../../../core'
import {
  useRouterOrgSlugFor,
  useSafeRouterOrgSlug,
} from '../../../utils/orgSlug'
import { serializeEncounterNavigationSource } from '../hooks/useEncounterNavigationSource'
import type { EncounterNavigationSource } from '../hooks/useEncounterNavigationSource'
import { usePracticeEncounterHrefs } from '../utils/appEncounterHrefs'
import { serializeEncounterRouteQueryParams } from '../utils/queryParams'
import type { EncounterRouteQueryParams } from '../utils/queryParams'
import type { LinkProps } from 'react-router-dom'
import type { Nullable } from 'nuqs'
export interface EncounterLinkProps extends Omit<LinkProps, 'to'> {
  encounterId: string
  navigationSource?: EncounterNavigationSource
  orgSlug?: string | null
  queryParams?: Partial<Nullable<EncounterRouteQueryParams>> | null
}

export function EncounterLink({
  children,
  encounterId,
  navigationSource,
  orgSlug,
  queryParams = null,
  rel,
  target,
  ...restProps
}: EncounterLinkProps) {
  const currentRouterOrgSlug = useSafeRouterOrgSlug()
  const providedRouterOrgSlug = useRouterOrgSlugFor(orgSlug ?? null)
  const { getPracticeEncounterHref } = usePracticeEncounterHrefs()
  const resolvedOrgSlug =
    orgSlug === undefined ? currentRouterOrgSlug : providedRouterOrgSlug
  const encounterHref =
    resolvedOrgSlug === null
      ? undefined
      : getPracticeEncounterHref({
          encounterId,
          orgSlug: resolvedOrgSlug,
        })

  if (!encounterHref) {
    return <span {...restProps}>{children}</span>
  }

  const baseUrl = serializeEncounterRouteQueryParams(encounterHref, queryParams)
  const to = navigationSource
    ? serializeEncounterNavigationSource(baseUrl, navigationSource)
    : baseUrl

  return (
    <RouterAwareLink to={to} target={target} rel={rel} {...restProps}>
      {children}
    </RouterAwareLink>
  )
}
